module.exports = __webpack_public_path__ + "static/media/arrow-down-b.ef57f758.svg";